import {Component, OnDestroy, OnInit} from '@angular/core';
import {Account} from "../shared/models/account";
import {SessionService} from "../core/service/session.service";
// import {AppInitService} from "../core/service/app-init.service";
import {SvgIconService} from "../core/service/svg-icon.service";
import {MatDialog} from "@angular/material/dialog";
import {ModalComponent} from "./modal/modal.component";
import {DIALOG_WIDTH} from "../shared/constants";
import {MessageService} from "../core/service/message.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  showPassword = false;
  account = new Account();

  constructor(private sessionService: SessionService,
              // private appInitService: AppInitService,
              private svgIconService: SvgIconService,
              public messageService: MessageService,
              public dialog: MatDialog) {
    this.account.email = '';
  }

  ngOnInit(): void {
    this.svgIconService.registerIcons();
  }

  ngOnDestroy() {
    location.reload();
  }

  submitLogin($event: any) {
    $event.preventDefault();
    this.sessionService.loginWithEmailAndPassword(this.account);
  }

  sendPasswordResetEmail() {
    const dialogRef = this.dialog.open(ModalComponent, {
      width: DIALOG_WIDTH,
      data: {
        mail: this.account.email
      }
    })

    dialogRef.afterClosed().toPromise().then(result => {
      if (!result?.mail) return;
      this.messageService.pushInfo('送信中...')
      this.sessionService.sendPasswordResetEmail(result.mail);
    })
  }

  logout() {
    this.sessionService.logout()
  }
}
